type RichTextItem = {
  children: [
    {
      text?: string;
      url?: string;
    }
  ];
};

export function parseRichText(value: string): RichTextItem[] | undefined {
  try {
    const parsedContent = JSON.parse(value) as RichTextItem[];
    return parsedContent;
  } catch (error) {
    return undefined;
  }
}

export function hasRichTextContent(value: string): boolean {
  const richText = parseRichText(value);
  return !!richText?.some((item) => {
    return item.children.some((c) => c.text || c.url);
  });
}
